import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import EmptyMap from 'shared/images/empty_map.svg'
import { Button } from 'shared/ui/button'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface ErrorMapProps {
  error: string | null
  onTryAgain?: () => void
}

export const ErrorMap = ({ error, onTryAgain }: ErrorMapProps) => {
  const { t } = useTranslation()
  return (
    <div className={clsx(s.container, 'container')}>
      <ImageLazy src={EmptyMap} />

      <div className={s.content}>
        <p className={clsx('bold-22', s.title)}>
          {t('tours_block.error_map_title')}
        </p>
        <p className={clsx('medium-14', s.description)}>{error}</p>
      </div>

      {onTryAgain && (
        <Button
          variant="solidBlue"
          className="bold-16"
          onClick={onTryAgain}
        >
          {t('tours_block.error_map_button')}
        </Button>
      )}
    </div>
  )
}
